export default {

    "--background-color": "#212531",
    "--page-background-color": "#1a1e27",
    "--sidebar-obj-background-color": "#262b39",
    "--obj-background-color": "#262b39",
    "--obj-background-color-hover": "#1d212c",
    "--obj-border-color": '#FFFFFF09',
    "--text-color": "#ffffff",
    "--text-color-alpha": "#ffffff88",
    "--tab-color": "#212733",
    "--tab-color-selected": "#2d3341",

    "--highlight-tab": "#f8f8f2",
    "--highlight-emphasis": "#a8a8a2",
    "--highlight-primitive": "#e1fc69",
    "--highlight-class": "#26eb37",
    "--highlight-tag": "#5c87ff",
    "--highlight-attr": "#66d9ef",
    "--highlight-params": "#f8f8f2",
    "--highlight-type": "#eb2668",
    "--highlight-meta": "#eb2668EE",
    "--highlight-comment": "#ffffff6e",
    "--highlight-string": "#69d8a0",
}